const capitalizeFirstLetter = (str: string) => str.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

const TextOperations = {
    capitalizeFirstLetter
}

export default TextOperations;